import React, { useState, Component } from 'react';
import { ArrowLeftIcon, MapPinIcon, EditIcon, CompassIcon, PackageIcon, TruckIcon, BarChart3Icon, BoxIcon, ClipboardListIcon, HistoryIcon, CalendarIcon, AlertCircleIcon, CheckCircleIcon, SearchIcon, FilterIcon, PlusIcon, DownloadIcon, RefreshCwIcon, ChevronDownIcon, ChevronRightIcon, SettingsIcon, UserIcon, ArrowRightIcon, PieChartIcon, EyeIcon, TrashIcon, XCircleIcon, InfoIcon, SlidersIcon, ArrowUpDownIcon, CheckIcon, ListFilterIcon, ShieldIcon, TrendingUpIcon, TrendingDownIcon, ThumbsUpIcon, ThumbsDownIcon, PercentIcon, PrinterIcon, ArchiveIcon, HelpCircleIcon, BellIcon, FileTextIcon, TagIcon, ZapIcon } from 'lucide-react';
export function WarehouseDetails({
  id = 'IU1',
  name = 'Pierce - San Antonio',
  location = '6203 Woodlake Center TEXAS San Antonio United States',
  flag = '🇺🇸',
  stock = '2%',
  machines = '7',
  onBack
}) {
  const [activeTab, setActiveTab] = useState('details');
  const [activeStockTab, setActiveStockTab] = useState('stockByDesign');
  const [stockFilter, setStockFilter] = useState('all');
  const [stockSort, setStockSort] = useState('name');
  const [showStockTemplateModal, setShowStockTemplateModal] = useState(false);
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  // Mock data for the warehouse details
  const warehouseData = {
    oracleCode: id,
    organizationId: '9946',
    name: location.split(' ').pop(),
    region: 'Aisco AMERICA',
    address: location,
    zipCode: '78244',
    coordinates: '29.485804, -98.360062'
  };
  // Mock data for machine stock
  const machineStockData = [{
    id: 'M001',
    name: '6" 5/8 GALV',
    type: 'Pivot Machine',
    desiredStock: 100,
    stats: {
      lowStock: 1,
      overStock: 90,
      covered: 7,
      orderRequired: 2
    },
    atHand: 0,
    incoming: 0,
    lastUpdated: '2023-10-15',
    status: 'Critical',
    priority: 'High',
    category: 'Irrigation',
    trend: 'decreasing',
    forecast: 'Needs restock within 7 days'
  }, {
    id: 'M002',
    name: '8" 5/8 GALV',
    type: 'Pivot Machine',
    desiredStock: 30,
    stats: {
      lowStock: 0,
      overStock: 80,
      covered: 20,
      orderRequired: 0
    },
    atHand: 7,
    incoming: 21,
    lastUpdated: '2023-10-18',
    status: 'Good',
    priority: 'Medium',
    category: 'Irrigation',
    trend: 'stable',
    forecast: 'Stock levels adequate for 30 days'
  }, {
    id: 'M003',
    name: '5" GALV',
    type: 'Pivot Machine',
    desiredStock: 20,
    stats: {
      lowStock: 4,
      overStock: 71,
      covered: 15,
      orderRequired: 10
    },
    atHand: 0,
    incoming: 5,
    lastUpdated: '2023-10-12',
    status: 'Warning',
    priority: 'Medium',
    category: 'Irrigation',
    trend: 'increasing',
    forecast: 'Incoming shipment will improve levels'
  }, {
    id: 'M004',
    name: 'High Profile',
    type: 'Pivot Machine',
    desiredStock: 20,
    stats: {
      lowStock: 0,
      overStock: 99,
      covered: 1,
      orderRequired: 0
    },
    atHand: 0,
    incoming: 0,
    lastUpdated: '2023-10-05',
    status: 'Critical',
    priority: 'Low',
    category: 'Specialized',
    trend: 'stable',
    forecast: 'Low demand, no immediate action needed'
  }, {
    id: 'M005',
    name: 'Linear',
    type: 'Linear',
    desiredStock: 15,
    stats: {
      lowStock: 17,
      overStock: 8,
      covered: 65,
      orderRequired: 10
    },
    atHand: 1,
    incoming: 0,
    lastUpdated: '2023-10-19',
    status: 'Warning',
    priority: 'High',
    category: 'Linear Systems',
    trend: 'decreasing',
    forecast: 'Order required within 14 days'
  }, {
    id: 'M006',
    name: 'Corner Arm',
    type: 'Pivot Accessory',
    desiredStock: 8,
    stats: {
      lowStock: 0,
      overStock: 0,
      covered: 100,
      orderRequired: 0
    },
    atHand: 8,
    incoming: 2,
    lastUpdated: '2023-10-17',
    status: 'Optimal',
    priority: 'Low',
    category: 'Accessories',
    trend: 'increasing',
    forecast: 'Stock levels optimal'
  }];
  // Consolidated stock data
  const consolidatedStock = {
    name: 'Stock Consolidated',
    stats: {
      lowStock: 2,
      overStock: 85,
      covered: 6,
      orderRequired: 7
    },
    percentage: '2%',
    atHand: 7,
    incoming: 21,
    trend: {
      weekly: '+2%',
      monthly: '-5%',
      quarterly: '+12%'
    },
    healthScore: 68,
    alertCount: 3,
    lastUpdated: '2023-10-20'
  };
  // Filter and sort machines based on current selections
  const getFilteredAndSortedMachines = () => {
    let filtered = [...machineStockData];
    // Apply filters
    if (stockFilter === 'critical') {
      filtered = filtered.filter(m => m.status === 'Critical');
    } else if (stockFilter === 'warning') {
      filtered = filtered.filter(m => m.status === 'Warning');
    } else if (stockFilter === 'good') {
      filtered = filtered.filter(m => m.status === 'Good' || m.status === 'Optimal');
    } else if (stockFilter === 'incoming') {
      filtered = filtered.filter(m => m.incoming > 0);
    } else if (stockFilter === 'nostock') {
      filtered = filtered.filter(m => m.atHand === 0);
    }
    // Apply sorting
    if (stockSort === 'name') {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (stockSort === 'priority') {
      const priorityOrder = {
        High: 0,
        Medium: 1,
        Low: 2
      };
      filtered.sort((a, b) => priorityOrder[a.priority] - priorityOrder[b.priority]);
    } else if (stockSort === 'status') {
      const statusOrder = {
        Critical: 0,
        Warning: 1,
        Good: 2,
        Optimal: 3
      };
      filtered.sort((a, b) => statusOrder[a.status] - statusOrder[b.status]);
    } else if (stockSort === 'stock') {
      filtered.sort((a, b) => b.atHand - a.atHand);
    }
    return filtered;
  };
  // Get status counts for summary
  const getStatusCounts = () => {
    const counts = {
      critical: machineStockData.filter(m => m.status === 'Critical').length,
      warning: machineStockData.filter(m => m.status === 'Warning').length,
      good: machineStockData.filter(m => m.status === 'Good').length,
      optimal: machineStockData.filter(m => m.status === 'Optimal').length
    };
    return counts;
  };
  const statusCounts = getStatusCounts();
  const filteredMachines = getFilteredAndSortedMachines();
  // Mock data for inventory
  const inventoryData = [{
    category: 'Irrigation Parts',
    items: [{
      id: 'IP001',
      name: 'Sprinkler Head Type A',
      quantity: 120,
      unit: 'pcs',
      status: 'Optimal'
    }, {
      id: 'IP002',
      name: 'Pipe Connector 2"',
      quantity: 85,
      unit: 'pcs',
      status: 'Optimal'
    }, {
      id: 'IP003',
      name: 'Valve System B',
      quantity: 12,
      unit: 'sets',
      status: 'Low'
    }]
  }, {
    category: 'Electronic Components',
    items: [{
      id: 'EC001',
      name: 'Control Board v2',
      quantity: 8,
      unit: 'pcs',
      status: 'Low'
    }, {
      id: 'EC002',
      name: 'Sensor Package',
      quantity: 24,
      unit: 'pcs',
      status: 'Optimal'
    }]
  }, {
    category: 'Structural Elements',
    items: [{
      id: 'SE001',
      name: 'Support Beam 4m',
      quantity: 0,
      unit: 'pcs',
      status: 'Out of Stock'
    }, {
      id: 'SE002',
      name: 'Tower Section',
      quantity: 6,
      unit: 'sets',
      status: 'Low'
    }]
  }];
  // Mock data for alterations
  const alterationsData = [{
    id: 'ALT001',
    date: '2023-10-20',
    type: 'Stock Update',
    description: 'Added 4 Control Panel Pro units',
    user: 'Maria Rodriguez'
  }, {
    id: 'ALT002',
    date: '2023-10-18',
    type: 'Inventory Adjustment',
    description: 'Corrected Sprinkler Head Type A count from 110 to 120',
    user: 'John Smith'
  }, {
    id: 'ALT003',
    date: '2023-10-15',
    type: 'Machine Removal',
    description: 'Removed 1 Linear System A for maintenance',
    user: 'David Chen'
  }, {
    id: 'ALT004',
    date: '2023-10-10',
    type: 'Address Update',
    description: 'Updated warehouse zip code',
    user: 'Sarah Johnson'
  }, {
    id: 'ALT005',
    date: '2023-10-05',
    type: 'Stock Update',
    description: 'Received new shipment of Sensor Packages (24 units)',
    user: 'Maria Rodriguez'
  }];
  return <div className="bg-gradient-to-r from-blue-950 via-indigo-900 to-teal-900 min-h-screen text-white" data-id="element-6276">
      {/* Header with enhanced styling */}
      <div className="p-5 flex items-center bg-gradient-to-r from-blue-900/80 to-indigo-900/80 backdrop-blur-sm shadow-md" data-id="element-6277">
        <button onClick={onBack} className="mr-4 p-2 text-white bg-gradient-to-br from-white/20 to-white/5 hover:from-white/30 hover:to-white/10 rounded-full transition-all duration-300 shadow-lg" data-id="element-6278">
          <ArrowLeftIcon size={20} data-id="element-6279" />
        </button>
        <div data-id="element-6280">
          <div className="flex items-center" data-id="element-6281">
            <h1 className="text-2xl font-bold" data-id="element-6282">{name}</h1>
            <span className="ml-2 text-2xl" data-id="element-6283">{flag}</span>
          </div>
          <div className="flex items-center text-blue-100 text-sm mt-1" data-id="element-6284">
            <span className="bg-gradient-to-r from-blue-800/70 to-indigo-800/70 px-2 py-0.5 rounded-md" data-id="element-6285">
              {id}
            </span>
            <span className="mx-2" data-id="element-6286">|</span>
            <MapPinIcon size={14} className="mr-1" data-id="element-6287" />
            <span data-id="element-6288">{location}</span>
          </div>
        </div>
      </div>
      {/* Tabs with enhanced styling */}
      <div className="border-b border-indigo-800 bg-gradient-to-r from-blue-900/40 to-indigo-900/40 backdrop-blur-sm" data-id="element-6289">
        <div className="flex px-4" data-id="element-6290">
          <TabButton icon={<ClipboardListIcon size={18} data-id="element-6292" />} label="Details" active={activeTab === 'details'} onClick={() => setActiveTab('details')} data-id="element-6291" />
          <TabButton icon={<PackageIcon size={18} data-id="element-6294" />} label="Machine Stock" active={activeTab === 'machineStock'} onClick={() => setActiveTab('machineStock')} data-id="element-6293" />
          <TabButton icon={<BoxIcon size={18} data-id="element-6296" />} label="Inventory" active={activeTab === 'inventory'} onClick={() => setActiveTab('inventory')} data-id="element-6295" />
          <TabButton icon={<HistoryIcon size={18} data-id="element-6298" />} label="Alterations" active={activeTab === 'alterations'} onClick={() => setActiveTab('alterations')} data-id="element-6297" />
        </div>
      </div>
      {/* Content with improved spacing */}
      <div className="p-6 md:p-8" data-id="element-6299">
        {activeTab === 'details' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6300">
            <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6301">
              <h2 className="text-xl font-bold flex items-center text-indigo-800" data-id="element-6302">
                <ClipboardListIcon size={22} className="mr-3 text-indigo-600" data-id="element-6303" />
                Warehouse Details
              </h2>
            </div>
            <div className="p-6 md:p-8" data-id="element-6304">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6305">
                <div className="space-y-6" data-id="element-6306">
                  <DetailRow icon={<BoxIcon size={18} className="text-indigo-600" data-id="element-6308" />} label="Oracle Code:" value={warehouseData.oracleCode} data-id="element-6307" />
                  <DetailRow icon={<BarChart3Icon size={18} className="text-indigo-600" data-id="element-6310" />} label="Organization ID:" value={warehouseData.organizationId} data-id="element-6309" />
                  <DetailRow icon={<MapPinIcon size={18} className="text-indigo-600" data-id="element-6312" />} label="Name:" value={warehouseData.name} data-id="element-6311" />
                  <DetailRow icon={<TruckIcon size={18} className="text-indigo-600" data-id="element-6314" />} label="Region:" value={warehouseData.region} data-id="element-6313" />
                </div>
                <div className="space-y-6" data-id="element-6315">
                  <DetailRow icon={<MapPinIcon size={18} className="text-indigo-600" data-id="element-6317" />} label="Address:" value={warehouseData.address} data-id="element-6316" />
                  <DetailRow icon={<MapPinIcon size={18} className="text-indigo-600" data-id="element-6319" />} label="Zip Code:" value={warehouseData.zipCode} data-id="element-6318" />
                  <DetailRow icon={<CompassIcon size={18} className="text-indigo-600" data-id="element-6321" />} label="Coordinates:" value={warehouseData.coordinates} data-id="element-6320" />
                </div>
              </div>
              {/* Map placeholder with improved styling */}
              <div className="mt-8 bg-gradient-to-b from-blue-50 via-indigo-50 to-gray-50 rounded-xl p-6 h-64 flex items-center justify-center shadow-inner" data-id="element-6322">
                <div className="text-center" data-id="element-6323">
                  <div className="bg-gradient-to-br from-white to-blue-50 p-4 rounded-full shadow-md inline-block mb-4" data-id="element-6324">
                    <CompassIcon size={40} className="text-indigo-500" data-id="element-6325" />
                  </div>
                  <p className="text-gray-600 font-medium" data-id="element-6326">
                    Interactive map would be displayed here
                  </p>
                  <p className="text-sm text-gray-500 mt-2 flex items-center justify-center" data-id="element-6327">
                    <MapPinIcon size={14} className="mr-1" data-id="element-6328" />
                    {warehouseData.coordinates}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-8 py-5 flex justify-end" data-id="element-6329">
              <button className="flex items-center text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 px-5 py-2.5 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg" data-id="element-6330">
                <EditIcon size={16} className="mr-2" data-id="element-6331" />
                Edit Warehouse Details
              </button>
            </div>
          </div>}
        {activeTab === 'machineStock' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6332">
            {/* Sub-tabs navigation with improved styling */}
            <div className="border-b border-gray-200 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6333">
              <div className="flex" data-id="element-6334">
                <StockTabButton label="Stock By Design" active={activeStockTab === 'stockByDesign'} onClick={() => setActiveStockTab('stockByDesign')} data-id="element-6335" />
                <StockTabButton label="Stock in transit" active={activeStockTab === 'stockInTransit'} onClick={() => setActiveStockTab('stockInTransit')} data-id="element-6336" />
                <button className="px-5 py-3.5 text-gray-600 hover:text-gray-800 flex items-center transition-colors" data-id="element-6337">
                  <SettingsIcon size={16} className="mr-2" data-id="element-6338" />
                  Settings
                </button>
              </div>
            </div>
            {activeStockTab === 'stockByDesign' && <>
                {/* Enhanced dashboard header with improved styling */}
                <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-white to-blue-50" data-id="element-6339">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-6340">
                    <div data-id="element-6341">
                      <h2 className="text-xl font-bold text-gray-800 flex items-center" data-id="element-6342">
                        <PackageIcon size={22} className="mr-2 text-indigo-600" data-id="element-6343" />
                        Machine Stock Management
                      </h2>
                      <p className="text-gray-600 mt-1" data-id="element-6344">
                        Monitor and manage machine stock levels across your
                        warehouse
                      </p>
                    </div>
                    <div className="flex flex-wrap gap-3" data-id="element-6345">
                      <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" onClick={() => setShowFilterPanel(!showFilterPanel)} data-id="element-6346">
                        <FilterIcon size={16} className="mr-2" data-id="element-6347" />
                        Filter
                        <span className={`ml-1 flex items-center justify-center h-5 w-5 text-xs rounded-full ${stockFilter !== 'all' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-500'}`} data-id="element-6348">
                          {stockFilter !== 'all' ? '1' : '0'}
                        </span>
                      </button>
                      <div className="relative group" data-id="element-6349">
                        <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6350">
                          <ArrowUpDownIcon size={16} className="mr-2" data-id="element-6351" />
                          Sort By
                          <ChevronDownIcon size={16} className="ml-2" data-id="element-6352" />
                        </button>
                        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10" data-id="element-6353">
                          <div className="py-1" data-id="element-6354">
                            <SortOption label="Name" active={stockSort === 'name'} onClick={() => setStockSort('name')} data-id="element-6355" />
                            <SortOption label="Priority" active={stockSort === 'priority'} onClick={() => setStockSort('priority')} data-id="element-6356" />
                            <SortOption label="Status" active={stockSort === 'status'} onClick={() => setStockSort('status')} data-id="element-6357" />
                            <SortOption label="Stock Level" active={stockSort === 'stock'} onClick={() => setStockSort('stock')} data-id="element-6358" />
                          </div>
                        </div>
                      </div>
                      <button className="flex items-center text-white bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 px-4 py-2 rounded-lg transition-all shadow-md hover:shadow-lg" onClick={() => setShowStockTemplateModal(true)} data-id="element-6359">
                        <PlusIcon size={16} className="mr-2" data-id="element-6360" />
                        Create Template
                      </button>
                      <button className="flex items-center text-gray-700 border border-gray-300 px-3 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6361">
                        <DownloadIcon size={16} data-id="element-6362" />
                      </button>
                      <button className="flex items-center text-gray-700 border border-gray-300 px-3 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6363">
                        <PrinterIcon size={16} data-id="element-6364" />
                      </button>
                    </div>
                  </div>
                  {/* Filter panel */}
                  {showFilterPanel && <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-100 animate-fadeIn" data-id="element-6365">
                      <div className="flex items-center justify-between mb-3" data-id="element-6366">
                        <h3 className="font-medium text-indigo-800 flex items-center" data-id="element-6367">
                          <ListFilterIcon size={16} className="mr-2" data-id="element-6368" />
                          Filter Machine Stock
                        </h3>
                        <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowFilterPanel(false)} data-id="element-6369">
                          <XCircleIcon size={18} data-id="element-6370" />
                        </button>
                      </div>
                      <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-id="element-6371">
                        <FilterButton label="All Machines" active={stockFilter === 'all'} onClick={() => setStockFilter('all')} count={machineStockData.length} data-id="element-6372" />
                        <FilterButton label="Critical Stock" active={stockFilter === 'critical'} onClick={() => setStockFilter('critical')} count={statusCounts.critical} color="red" data-id="element-6373" />
                        <FilterButton label="Warning Stock" active={stockFilter === 'warning'} onClick={() => setStockFilter('warning')} count={statusCounts.warning} color="amber" data-id="element-6374" />
                        <FilterButton label="Good Stock" active={stockFilter === 'good'} onClick={() => setStockFilter('good')} count={statusCounts.good + statusCounts.optimal} color="green" data-id="element-6375" />
                        <FilterButton label="Incoming" active={stockFilter === 'incoming'} onClick={() => setStockFilter('incoming')} count={machineStockData.filter(m => m.incoming > 0).length} color="blue" data-id="element-6376" />
                        <FilterButton label="No Stock" active={stockFilter === 'nostock'} onClick={() => setStockFilter('nostock')} count={machineStockData.filter(m => m.atHand === 0).length} color="gray" data-id="element-6377" />
                      </div>
                    </div>}
                </div>
                {/* Summary cards row */}
                <div className="p-6 grid grid-cols-1 md:grid-cols-4 gap-4 bg-gradient-to-br from-white to-blue-50" data-id="element-6378">
                  <div className="bg-gradient-to-br from-indigo-50 to-blue-100 rounded-xl p-4 border border-blue-200 shadow-md" data-id="element-6379">
                    <div className="flex items-center justify-between" data-id="element-6380">
                      <div data-id="element-6381">
                        <p className="text-sm font-medium text-indigo-800" data-id="element-6382">
                          Overall Stock Health
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-indigo-900" data-id="element-6383">
                          {consolidatedStock.healthScore}
                          <span className="text-sm font-normal text-indigo-700" data-id="element-6384">
                            /100
                          </span>
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-indigo-400 to-blue-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6385">
                        <ShieldIcon size={24} className="text-white" data-id="element-6386" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm" data-id="element-6387">
                      <span className={`flex items-center ${consolidatedStock.trend.weekly.startsWith('+') ? 'text-green-700' : 'text-red-700'}`} data-id="element-6388">
                        {consolidatedStock.trend.weekly.startsWith('+') ? <TrendingUpIcon size={14} className="mr-1" data-id="element-6389" /> : <TrendingDownIcon size={14} className="mr-1" data-id="element-6390" />}
                        {consolidatedStock.trend.weekly} this week
                      </span>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-red-50 to-rose-100 rounded-xl p-4 border border-red-200 shadow-md" data-id="element-6391">
                    <div className="flex items-center justify-between" data-id="element-6392">
                      <div data-id="element-6393">
                        <p className="text-sm font-medium text-red-800" data-id="element-6394">
                          Critical Stock
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-red-900" data-id="element-6395">
                          {statusCounts.critical}
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-red-400 to-rose-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6396">
                        <AlertCircleIcon size={24} className="text-white" data-id="element-6397" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm text-red-800" data-id="element-6398">
                      <ThumbsDownIcon size={14} className="mr-1" data-id="element-6399" />
                      Needs immediate attention
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-green-50 to-emerald-100 rounded-xl p-4 border border-green-200 shadow-md" data-id="element-6400">
                    <div className="flex items-center justify-between" data-id="element-6401">
                      <div data-id="element-6402">
                        <p className="text-sm font-medium text-green-800" data-id="element-6403">
                          Optimal Stock
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-green-900" data-id="element-6404">
                          {statusCounts.optimal}
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6405">
                        <CheckCircleIcon size={24} className="text-white" data-id="element-6406" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm text-green-800" data-id="element-6407">
                      <ThumbsUpIcon size={14} className="mr-1" data-id="element-6408" />
                      Well-stocked machines
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-amber-50 to-yellow-100 rounded-xl p-4 border border-amber-200 shadow-md" data-id="element-6409">
                    <div className="flex items-center justify-between" data-id="element-6410">
                      <div data-id="element-6411">
                        <p className="text-sm font-medium text-amber-800" data-id="element-6412">
                          Incoming Shipments
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-amber-900" data-id="element-6413">
                          {machineStockData.filter(m => m.incoming > 0).length}
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6414">
                        <TruckIcon size={24} className="text-white" data-id="element-6415" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm text-amber-800" data-id="element-6416">
                      <CalendarIcon size={14} className="mr-1" data-id="element-6417" />
                      Next arrival: 3 days
                    </div>
                  </div>
                </div>
                {/* Consolidated stock card - enhanced */}
                <div className="px-6 pt-2 pb-6 bg-gradient-to-br from-white to-blue-50" data-id="element-6418">
                  <div className="bg-gradient-to-br from-white via-blue-50 to-indigo-100 border border-blue-200 rounded-xl overflow-hidden shadow-lg" data-id="element-6419">
                    <div className="p-5 border-b border-blue-100" data-id="element-6420">
                      <div className="flex justify-between items-start" data-id="element-6421">
                        <div data-id="element-6422">
                          <div className="flex items-center" data-id="element-6423">
                            <h3 className="font-bold text-xl text-indigo-800" data-id="element-6424">
                              {consolidatedStock.name}
                            </h3>
                            <span className="ml-3 bg-gradient-to-r from-blue-100 to-indigo-100 text-indigo-700 text-xs px-2.5 py-0.5 rounded-full" data-id="element-6425">
                              Last updated: {consolidatedStock.lastUpdated}
                            </span>
                          </div>
                          <p className="text-gray-600 mt-1" data-id="element-6426">
                            Comprehensive overview of all machine stock in this
                            warehouse
                          </p>
                        </div>
                        <div className="bg-gradient-to-br from-blue-100 to-indigo-200 p-2 rounded-full" data-id="element-6427">
                          <PieChartIcon size={24} className="text-indigo-600" data-id="element-6428" />
                        </div>
                      </div>
                      <div className="mt-5 grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-6429">
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6430">
                          <div className="flex items-center justify-between" data-id="element-6431">
                            <div data-id="element-6432">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6433">
                                Total Machines
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-gray-800" data-id="element-6434">
                                {machineStockData.length}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center" data-id="element-6435">
                              <PackageIcon size={20} className="text-gray-700" data-id="element-6436" />
                            </div>
                          </div>
                        </div>
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6437">
                          <div className="flex items-center justify-between" data-id="element-6438">
                            <div data-id="element-6439">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6440">
                                Machines at Hand
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-indigo-700" data-id="element-6441">
                                {consolidatedStock.atHand}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-indigo-100 to-blue-200 rounded-full flex items-center justify-center" data-id="element-6442">
                              <BoxIcon size={20} className="text-indigo-700" data-id="element-6443" />
                            </div>
                          </div>
                        </div>
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6444">
                          <div className="flex items-center justify-between" data-id="element-6445">
                            <div data-id="element-6446">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6447">
                                Incoming Machines
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-teal-600" data-id="element-6448">
                                {consolidatedStock.incoming}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-teal-100 to-green-200 rounded-full flex items-center justify-center" data-id="element-6449">
                              <TruckIcon size={20} className="text-teal-700" data-id="element-6450" />
                            </div>
                          </div>
                        </div>
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6451">
                          <div className="flex items-center justify-between" data-id="element-6452">
                            <div data-id="element-6453">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6454">
                                Alerts
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-amber-600" data-id="element-6455">
                                {consolidatedStock.alertCount}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-amber-100 to-orange-200 rounded-full flex items-center justify-center" data-id="element-6456">
                              <BellIcon size={20} className="text-amber-700" data-id="element-6457" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-5" data-id="element-6458">
                      <div className="flex justify-between items-start mb-6" data-id="element-6459">
                        <div className="space-y-4 w-full max-w-md" data-id="element-6460">
                          <h4 className="font-medium text-gray-800" data-id="element-6461">
                            Stock Distribution
                          </h4>
                          <div className="space-y-3" data-id="element-6462">
                            <StockStatItemEnhanced color="yellow" label="Low Stock" value={`${consolidatedStock.stats.lowStock}%`} icon={<AlertCircleIcon size={14} data-id="element-6464" />} data-id="element-6463" />
                            <StockStatItemEnhanced color="orange" label="Over Stock" value={`${consolidatedStock.stats.overStock}%`} icon={<PercentIcon size={14} data-id="element-6466" />} data-id="element-6465" />
                            <StockStatItemEnhanced color="green" label="Covered" value={`${consolidatedStock.stats.covered}%`} icon={<CheckIcon size={14} data-id="element-6468" />} data-id="element-6467" />
                            <StockStatItemEnhanced color="red" label="Order Required" value={`${consolidatedStock.stats.orderRequired}%`} icon={<ShoppingCartIcon size={14} className="text-indigo-600" data-id="element-6470" />} data-id="element-6469" />
                          </div>
                        </div>
                        <div className="text-center" data-id="element-6471">
                          <div className="relative" data-id="element-6472">
                            <div className="w-32 h-32 rounded-full flex items-center justify-center bg-gradient-to-br from-blue-100 to-indigo-200 border-4 border-indigo-200 shadow-md" data-id="element-6473">
                              <div className="text-center" data-id="element-6474">
                                <span className="text-4xl font-bold text-indigo-800" data-id="element-6475">
                                  {consolidatedStock.percentage}
                                </span>
                                <p className="text-xs font-medium text-indigo-600 mt-1" data-id="element-6476">
                                  Overall Stock
                                </p>
                              </div>
                            </div>
                            <div className="absolute -bottom-2 -right-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-xs px-2.5 py-1 rounded-full shadow-md" data-id="element-6477">
                              <ZapIcon size={14} className="inline mr-1" data-id="element-6478" />
                              Status
                            </div>
                          </div>
                          <div className="mt-4 grid grid-cols-3 gap-2 text-xs" data-id="element-6479">
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-100 rounded-lg p-2" data-id="element-6480">
                              <div className="font-medium text-indigo-800" data-id="element-6481">
                                Weekly
                              </div>
                              <div className={`font-bold ${consolidatedStock.trend.weekly.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-6482">
                                {consolidatedStock.trend.weekly}
                              </div>
                            </div>
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-100 rounded-lg p-2" data-id="element-6483">
                              <div className="font-medium text-indigo-800" data-id="element-6484">
                                Monthly
                              </div>
                              <div className={`font-bold ${consolidatedStock.trend.monthly.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-6485">
                                {consolidatedStock.trend.monthly}
                              </div>
                            </div>
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-100 rounded-lg p-2" data-id="element-6486">
                              <div className="font-medium text-indigo-800" data-id="element-6487">
                                Quarterly
                              </div>
                              <div className={`font-bold ${consolidatedStock.trend.quarterly.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-6488">
                                {consolidatedStock.trend.quarterly}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-t border-blue-100 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 flex justify-between items-center" data-id="element-6489">
                      <button className="text-indigo-600 hover:text-indigo-800 hover:bg-white/50 font-medium flex items-center py-2 px-4 rounded-lg transition-colors" data-id="element-6490">
                        <FileTextIcon size={16} className="mr-2" data-id="element-6491" />
                        Generate Report
                      </button>
                      <div className="flex space-x-2" data-id="element-6492">
                        <button className="text-indigo-600 hover:text-indigo-800 hover:bg-white/50 font-medium flex items-center py-2 px-4 rounded-lg transition-colors" data-id="element-6493">
                          <EyeIcon size={16} className="mr-2" data-id="element-6494" />
                          View Details
                        </button>
                        <button className="text-gray-600 hover:text-gray-800 hover:bg-white/50 font-medium flex items-center py-2 px-4 rounded-lg transition-colors" data-id="element-6495">
                          <SettingsIcon size={16} className="mr-2" data-id="element-6496" />
                          Configure
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Machine stock cards - enhanced grid */}
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 bg-gradient-to-br from-white to-blue-50" data-id="element-6497">
                  {filteredMachines.map(machine => <MachineStockCard key={machine.id} machine={machine} data-id="element-6498" />)}
                </div>
                {/* Pagination */}
                <div className="p-6 border-t border-gray-200 bg-gradient-to-r from-gray-50 to-blue-50 flex justify-between items-center" data-id="element-6499">
                  <div className="text-sm text-gray-600" data-id="element-6500">
                    Showing{' '}
                    <span className="font-medium" data-id="element-6501">
                      {filteredMachines.length}
                    </span>{' '}
                    of{' '}
                    <span className="font-medium" data-id="element-6502">
                      {machineStockData.length}
                    </span>{' '}
                    machines
                  </div>
                  <div className="flex space-x-1" data-id="element-6503">
                    <button className="px-3 py-1 border border-gray-300 rounded-md text-gray-600 hover:bg-white" data-id="element-6504">
                      &laquo;
                    </button>
                    <button className="px-3 py-1 border border-gray-300 rounded-md bg-indigo-100 text-indigo-700 font-medium" data-id="element-6505">
                      1
                    </button>
                    <button className="px-3 py-1 border border-gray-300 rounded-md text-gray-600 hover:bg-white" data-id="element-6506">
                      &raquo;
                    </button>
                  </div>
                </div>
              </>}
            {activeStockTab === 'stockInTransit' && <div className="p-8 flex items-center justify-center" data-id="element-6507">
                <div className="text-center" data-id="element-6508">
                  <TruckIcon size={48} className="mx-auto text-indigo-400 mb-4" data-id="element-6509" />
                  <h3 className="text-xl font-medium text-gray-800 mb-2" data-id="element-6510">
                    Stock in Transit
                  </h3>
                  <p className="text-gray-600" data-id="element-6511">
                    This section will show machines that are currently in
                    transit to this warehouse.
                  </p>
                </div>
              </div>}
            {/* Create Stock Template Modal */}
            {showStockTemplateModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-6512">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-fadeIn" data-id="element-6513">
                  <div className="p-5 border-b border-gray-200 flex justify-between items-center bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-6514">
                    <h3 className="text-lg font-bold text-gray-800 flex items-center" data-id="element-6515">
                      <PlusIcon size={18} className="mr-2 text-indigo-600" data-id="element-6516" />
                      Create Stock Template
                    </h3>
                    <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowStockTemplateModal(false)} data-id="element-6517">
                      <XCircleIcon size={20} data-id="element-6518" />
                    </button>
                  </div>
                  <div className="p-5" data-id="element-6519">
                    <div className="mb-4" data-id="element-6520">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6521">
                        Template Name
                      </label>
                      <input type="text" placeholder="Enter template name..." className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6522" />
                    </div>
                    <div className="mb-4" data-id="element-6523">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6524">
                        Description
                      </label>
                      <textarea placeholder="Enter template description..." rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6525"></textarea>
                    </div>
                    <div className="mb-4" data-id="element-6526">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6527">
                        Machine Type
                      </label>
                      <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6528">
                        <option data-id="element-6529">Pivot Machine</option>
                        <option data-id="element-6530">Linear</option>
                        <option data-id="element-6531">Pivot Accessory</option>
                      </select>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-6532">
                      <div data-id="element-6533">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6534">
                          Desired Stock
                        </label>
                        <input type="number" placeholder="0" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6535" />
                      </div>
                      <div data-id="element-6536">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6537">
                          Priority
                        </label>
                        <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6538">
                          <option data-id="element-6539">High</option>
                          <option data-id="element-6540">Medium</option>
                          <option data-id="element-6541">Low</option>
                        </select>
                      </div>
                    </div>
                    <div className="mb-4" data-id="element-6542">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6543">
                        Tags
                      </label>
                      <div className="flex flex-wrap gap-2 p-2 border border-gray-300 rounded-lg" data-id="element-6544">
                        <div className="bg-indigo-100 text-indigo-800 px-2 py-1 rounded-md text-sm flex items-center" data-id="element-6545">
                          Irrigation
                          <XCircleIcon size={14} className="ml-1 cursor-pointer" data-id="element-6546" />
                        </div>
                        <input type="text" placeholder="Add tag..." className="flex-1 border-0 focus:outline-none text-sm" data-id="element-6547" />
                      </div>
                    </div>
                  </div>
                  <div className="p-5 border-t border-gray-200 flex justify-end gap-3 bg-gradient-to-r from-gray-50 to-blue-50" data-id="element-6548">
                    <button className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100" onClick={() => setShowStockTemplateModal(false)} data-id="element-6549">
                      Cancel
                    </button>
                    <button className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-lg shadow-md" onClick={() => setShowStockTemplateModal(false)} data-id="element-6550">
                      Create Template
                    </button>
                  </div>
                </div>
              </div>}
          </div>}
        {activeTab === 'inventory' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6551">
            <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6552">
              <h2 className="text-xl font-bold flex items-center text-indigo-800" data-id="element-6553">
                <BoxIcon size={22} className="mr-3 text-indigo-600" data-id="element-6554" />
                Inventory Management
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-6555">
                View and manage all inventory items in this warehouse
              </p>
            </div>
            {/* Toolbar with improved styling */}
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 p-5 border-b border-gray-100 flex flex-wrap items-center justify-between gap-4" data-id="element-6556">
              <div className="relative" data-id="element-6557">
                <input type="text" placeholder="Search inventory..." className="pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 w-64 shadow-sm" data-id="element-6558" />
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-6559" />
              </div>
              <div className="flex gap-3" data-id="element-6560">
                <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2.5 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6561">
                  <FilterIcon size={16} className="mr-2" data-id="element-6562" />
                  Filter
                </button>
                <button className="flex items-center text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 px-4 py-2.5 rounded-lg transition-all shadow-md hover:shadow-lg" data-id="element-6563">
                  <PlusIcon size={16} className="mr-2" data-id="element-6564" />
                  Add Item
                </button>
              </div>
            </div>
            {/* Inventory categories with improved styling */}
            <div className="p-6 md:p-8 space-y-6" data-id="element-6565">
              {inventoryData.map((category, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6566">
                  <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-5 py-3.5 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-gray-100 hover:to-blue-100" data-id="element-6567">
                    <h3 className="font-medium text-gray-800 flex items-center" data-id="element-6568">
                      <BoxIcon size={18} className="mr-2 text-indigo-600" data-id="element-6569" />
                      {category.category}
                    </h3>
                    <ChevronDownIcon size={20} className="text-gray-500" data-id="element-6570" />
                  </div>
                  <div className="overflow-x-auto" data-id="element-6571">
                    <table className="w-full" data-id="element-6572">
                      <thead className="bg-gradient-to-r from-gray-50 to-indigo-50" data-id="element-6573">
                        <tr data-id="element-6574">
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6575">
                            ID
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6576">
                            Item Name
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6577">
                            Quantity
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6578">
                            Unit
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6579">
                            Status
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6580">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white" data-id="element-6581">
                        {category.items.map(item => <tr key={item.id} className="hover:bg-blue-50 transition-colors" data-id="element-6582">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-6583">
                              {item.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-6584">
                              {item.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium" data-id="element-6585">
                              {item.quantity}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-6586">
                              {item.unit}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-6587">
                              <StatusBadge status={item.status} data-id="element-6588" />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-6589">
                              <button className="text-indigo-600 hover:text-indigo-800 mr-3 font-medium" data-id="element-6590">
                                Edit
                              </button>
                              <button className="text-indigo-600 hover:text-indigo-800 font-medium" data-id="element-6591">
                                History
                              </button>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>)}
            </div>
            {/* Summary cards with improved styling */}
            <div className="px-8 pb-8 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6592">
              <div className="bg-gradient-to-br from-blue-50 via-blue-100 to-indigo-100 border border-blue-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6593">
                <div className="flex items-center justify-between mb-3" data-id="element-6594">
                  <h4 className="text-indigo-800 font-medium" data-id="element-6595">Total Items</h4>
                  <div className="bg-gradient-to-br from-blue-200 to-indigo-300 p-1.5 rounded-full" data-id="element-6596">
                    <BoxIcon size={18} className="text-indigo-700" data-id="element-6597" />
                  </div>
                </div>
                <p className="text-4xl font-bold text-indigo-700 mt-2" data-id="element-6598">267</p>
                <p className="text-indigo-600 text-sm mt-1 flex items-center" data-id="element-6599">
                  <InfoIcon size={14} className="mr-1" data-id="element-6600" />
                  Across all categories
                </p>
              </div>
              <div className="bg-gradient-to-br from-amber-50 via-amber-100 to-orange-100 border border-amber-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6601">
                <div className="flex items-center justify-between mb-3" data-id="element-6602">
                  <h4 className="text-amber-800 font-medium" data-id="element-6603">
                    Low Stock Items
                  </h4>
                  <div className="bg-gradient-to-br from-amber-200 to-orange-300 p-1.5 rounded-full" data-id="element-6604">
                    <AlertCircleIcon size={18} className="text-amber-700" data-id="element-6605" />
                  </div>
                </div>
                <p className="text-4xl font-bold text-amber-700 mt-2" data-id="element-6606">14</p>
                <p className="text-amber-600 text-sm mt-1 flex items-center" data-id="element-6607">
                  <InfoIcon size={14} className="mr-1" data-id="element-6608" />
                  Require attention
                </p>
              </div>
              <div className="bg-gradient-to-br from-red-50 via-red-100 to-rose-100 border border-red-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6609">
                <div className="flex items-center justify-between mb-3" data-id="element-6610">
                  <h4 className="text-red-800 font-medium" data-id="element-6611">Out of Stock</h4>
                  <div className="bg-gradient-to-br from-red-200 to-rose-300 p-1.5 rounded-full" data-id="element-6612">
                    <XCircleIcon size={18} className="text-red-700" data-id="element-6613" />
                  </div>
                </div>
                <p className="text-4xl font-bold text-red-700 mt-2" data-id="element-6614">3</p>
                <p className="text-red-600 text-sm mt-1 flex items-center" data-id="element-6615">
                  <InfoIcon size={14} className="mr-1" data-id="element-6616" />
                  Need immediate reorder
                </p>
              </div>
            </div>
          </div>}
        {activeTab === 'alterations' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6617">
            <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6618">
              <h2 className="text-xl font-bold flex items-center text-indigo-800" data-id="element-6619">
                <HistoryIcon size={22} className="mr-3 text-indigo-600" data-id="element-6620" />
                Alterations History
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-6621">
                Track all changes and updates made to this warehouse
              </p>
            </div>
            {/* Toolbar with improved styling */}
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 p-5 border-b border-gray-100 flex flex-wrap items-center justify-between gap-4" data-id="element-6622">
              <div className="relative" data-id="element-6623">
                <input type="text" placeholder="Search alterations..." className="pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 w-64 shadow-sm" data-id="element-6624" />
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-6625" />
              </div>
              <div className="flex gap-3" data-id="element-6626">
                <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2.5 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6627">
                  <FilterIcon size={16} className="mr-2" data-id="element-6628" />
                  Filter
                </button>
                <button className="flex items-center text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 px-4 py-2.5 rounded-lg transition-all shadow-md hover:shadow-lg" data-id="element-6629">
                  <DownloadIcon size={16} className="mr-2" data-id="element-6630" />
                  Export History
                </button>
              </div>
            </div>
            {/* Timeline with improved styling */}
            <div className="p-6 md:p-8" data-id="element-6631">
              <div className="space-y-8" data-id="element-6632">
                {alterationsData.map((alteration, index) => <div key={alteration.id} className="flex" data-id="element-6633">
                    <div className="relative" data-id="element-6634">
                      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-blue-100 to-indigo-200 flex items-center justify-center shadow-md z-10 relative" data-id="element-6635">
                        <HistoryIcon size={22} className="text-indigo-600" data-id="element-6636" />
                      </div>
                      {index < alterationsData.length - 1 && <div className="absolute top-12 bottom-0 left-1/2 w-0.5 bg-gradient-to-b from-indigo-200 to-blue-100 -ml-px h-full" data-id="element-6637"></div>}
                    </div>
                    <div className="ml-6 flex-1 bg-gradient-to-br from-white to-blue-50 rounded-xl border border-gray-100 shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden" data-id="element-6638">
                      <div className="p-5 border-b border-gray-50" data-id="element-6639">
                        <div className="flex items-center justify-between" data-id="element-6640">
                          <h3 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6641">
                            {alteration.type}
                            <span className="ml-3 bg-gradient-to-r from-blue-100 to-indigo-100 text-indigo-700 text-xs px-2.5 py-0.5 rounded-full" data-id="element-6642">
                              #{alteration.id}
                            </span>
                          </h3>
                          <div className="flex items-center text-sm text-gray-500 bg-gradient-to-r from-gray-50 to-blue-50 px-3 py-1 rounded-full" data-id="element-6643">
                            <CalendarIcon size={14} className="mr-1.5" data-id="element-6644" />
                            {alteration.date}
                          </div>
                        </div>
                        <p className="mt-3 text-gray-600" data-id="element-6645">
                          {alteration.description}
                        </p>
                        <div className="mt-4 flex items-center text-sm text-gray-500 bg-gradient-to-r from-gray-50 to-blue-50 inline-block px-3 py-1 rounded-full" data-id="element-6646">
                          <UserIcon size={14} className="mr-1.5" data-id="element-6647" />
                          By: {alteration.user}
                        </div>
                      </div>
                      <div className="px-5 py-2.5 bg-gradient-to-r from-gray-50 to-blue-50 flex justify-end" data-id="element-6648">
                        <button className="text-indigo-600 hover:text-indigo-800 text-sm font-medium flex items-center" data-id="element-6649">
                          View Details
                          <ArrowRightIcon size={14} className="ml-1" data-id="element-6650" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
            {/* Load more with improved styling */}
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-8 py-5 text-center border-t border-gray-100" data-id="element-6651">
              <button className="text-indigo-600 hover:text-indigo-800 font-medium flex items-center justify-center mx-auto bg-gradient-to-r from-white to-blue-50 px-5 py-2.5 rounded-lg border border-blue-200 shadow-sm hover:shadow-md transition-all" data-id="element-6652">
                <RefreshCwIcon size={16} className="mr-2" data-id="element-6653" />
                Load More History
              </button>
            </div>
          </div>}
      </div>
    </div>;
}
// Helper component for tab buttons
function TabButton({
  icon,
  label,
  active,
  onClick
}) {
  return <button className={`px-6 py-3.5 font-medium flex items-center transition-all duration-300 ${active ? 'border-b-2 border-white text-white' : 'text-gray-300 hover:text-white hover:bg-white/5'}`} onClick={onClick} data-id="element-6654">
      {icon && <span className="mr-2" data-id="element-6655">{icon}</span>}
      {label}
    </button>;
}
// Helper component for stock tab buttons
function StockTabButton({
  label,
  active,
  onClick
}) {
  return <button className={`px-6 py-3.5 font-medium transition-all duration-300 ${active ? 'border-b-2 border-indigo-500 text-indigo-600 bg-gradient-to-r from-blue-50 to-indigo-50' : 'text-gray-600 hover:text-gray-800 hover:bg-gradient-to-r hover:from-gray-50 hover:to-blue-50'}`} onClick={onClick} data-id="element-6656">
      {label}
    </button>;
}
// Helper component for detail rows
function DetailRow({
  icon,
  label,
  value
}) {
  return <div className="flex border-b border-gray-100 pb-4 hover:bg-gradient-to-r hover:from-gray-50 hover:to-blue-50 p-2 rounded-lg transition-colors" data-id="element-6657">
      <div className="w-48 font-medium flex items-center text-gray-700" data-id="element-6658">
        {icon && <span className="mr-2" data-id="element-6659">{icon}</span>}
        {typeof label === 'string' ? label : label}
      </div>
      <div className="flex-1 font-medium text-gray-900" data-id="element-6660">{value}</div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    icon: null
  };
  if (status === 'In Stock' || status === 'Optimal') {
    config = {
      color: 'green',
      icon: <CheckCircleIcon size={14} className="mr-1" data-id="element-6661" />
    };
  } else if (status === 'Low Stock' || status === 'Low') {
    config = {
      color: 'amber',
      icon: <AlertCircleIcon size={14} className="mr-1" data-id="element-6662" />
    };
  } else if (status === 'Out of Stock') {
    config = {
      color: 'red',
      icon: <XCircleIcon size={14} className="mr-1" data-id="element-6663" />
    };
  }
  const gradients = {
    green: 'bg-gradient-to-r from-green-100 to-emerald-100',
    amber: 'bg-gradient-to-r from-amber-100 to-yellow-100',
    red: 'bg-gradient-to-r from-red-100 to-rose-100',
    gray: 'bg-gradient-to-r from-gray-100 to-slate-100'
  };
  const textColors = {
    green: 'text-green-800',
    amber: 'text-amber-800',
    red: 'text-red-800',
    gray: 'text-gray-800'
  };
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${gradients[config.color]} ${textColors[config.color]}`} data-id="element-6664">
      {config.icon}
      {status}
    </span>;
}
// Helper component for stock stat items with colored dots
function StockStatItem({
  color,
  label
}) {
  const colors = {
    yellow: 'bg-gradient-to-r from-yellow-500 to-amber-500',
    orange: 'bg-gradient-to-r from-orange-500 to-amber-600',
    green: 'bg-gradient-to-r from-green-500 to-emerald-500',
    red: 'bg-gradient-to-r from-red-500 to-rose-500'
  };
  return <div className="flex items-center" data-id="element-6665">
      <div className={`h-3 w-3 rounded-full ${colors[color]} mr-2.5 shadow-sm`} data-id="element-6666"></div>
      <span className="text-sm font-medium text-gray-700" data-id="element-6667">{label}</span>
    </div>;
}
// Enhanced version of StockStatItem with value and icon
function StockStatItemEnhanced({
  color,
  label,
  value,
  icon
}) {
  const colors = {
    yellow: {
      dot: 'bg-gradient-to-r from-yellow-500 to-amber-500',
      text: 'text-amber-700',
      bg: 'bg-gradient-to-r from-yellow-50 to-amber-100'
    },
    orange: {
      dot: 'bg-gradient-to-r from-orange-500 to-amber-600',
      text: 'text-amber-700',
      bg: 'bg-gradient-to-r from-orange-50 to-amber-100'
    },
    green: {
      dot: 'bg-gradient-to-r from-green-500 to-emerald-500',
      text: 'text-green-700',
      bg: 'bg-gradient-to-r from-green-50 to-emerald-100'
    },
    red: {
      dot: 'bg-gradient-to-r from-red-500 to-rose-500',
      text: 'text-red-700',
      bg: 'bg-gradient-to-r from-red-50 to-rose-100'
    }
  };
  const colorConfig = colors[color];
  return <div className={`flex items-center justify-between py-2 px-3 rounded-lg ${colorConfig.bg}`} data-id="element-6668">
      <div className="flex items-center" data-id="element-6669">
        <div className={`h-3 w-3 rounded-full ${colorConfig.dot} mr-2.5 shadow-sm`} data-id="element-6670"></div>
        <span className="text-sm font-medium text-gray-800" data-id="element-6671">{label}</span>
      </div>
      <div className={`flex items-center ${colorConfig.text} font-medium`} data-id="element-6672">
        {icon && <span className="mr-1" data-id="element-6673">{icon}</span>}
        {value}
      </div>
    </div>;
}
// Helper component for stock progress bars
function StockProgressBar({
  label,
  value,
  color
}) {
  const colors = {
    yellow: {
      bg: 'bg-gradient-to-r from-yellow-50 to-amber-100',
      fill: 'bg-gradient-to-r from-yellow-400 to-amber-500',
      text: 'text-amber-800'
    },
    orange: {
      bg: 'bg-gradient-to-r from-orange-50 to-amber-100',
      fill: 'bg-gradient-to-r from-orange-400 to-amber-500',
      text: 'text-orange-800'
    },
    green: {
      bg: 'bg-gradient-to-r from-green-50 to-emerald-100',
      fill: 'bg-gradient-to-r from-green-400 to-emerald-500',
      text: 'text-green-800'
    },
    red: {
      bg: 'bg-gradient-to-r from-red-50 to-rose-100',
      fill: 'bg-gradient-to-r from-red-400 to-rose-500',
      text: 'text-red-800'
    }
  };
  const colorConfig = colors[color];
  return <div className="space-y-1" data-id="element-6674">
      <div className="flex justify-between items-center" data-id="element-6675">
        <span className="text-xs font-medium text-gray-700" data-id="element-6676">{label}</span>
        <span className={`text-xs font-medium ${colorConfig.text}`} data-id="element-6677">
          {value}%
        </span>
      </div>
      <div className={`w-full h-2 ${colorConfig.bg} rounded-full overflow-hidden`} data-id="element-6678">
        <div className={`h-full ${colorConfig.fill} rounded-full`} style={{
        width: `${value}%`
      }} data-id="element-6679"></div>
      </div>
    </div>;
}
// Helper component for filter buttons
function FilterButton({
  label,
  active,
  onClick,
  count,
  color = 'indigo'
}) {
  const colors = {
    indigo: {
      activeBg: 'bg-gradient-to-r from-indigo-500 to-blue-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-indigo-50',
      inactiveText: 'text-gray-700 hover:text-indigo-700',
      countBg: 'bg-indigo-100',
      countText: 'text-indigo-800'
    },
    red: {
      activeBg: 'bg-gradient-to-r from-red-500 to-rose-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-red-50',
      inactiveText: 'text-gray-700 hover:text-red-700',
      countBg: 'bg-red-100',
      countText: 'text-red-800'
    },
    amber: {
      activeBg: 'bg-gradient-to-r from-amber-500 to-orange-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-amber-50',
      inactiveText: 'text-gray-700 hover:text-amber-700',
      countBg: 'bg-amber-100',
      countText: 'text-amber-800'
    },
    green: {
      activeBg: 'bg-gradient-to-r from-green-500 to-emerald-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-green-50',
      inactiveText: 'text-gray-700 hover:text-green-700',
      countBg: 'bg-green-100',
      countText: 'text-green-800'
    },
    blue: {
      activeBg: 'bg-gradient-to-r from-blue-500 to-sky-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-blue-50',
      inactiveText: 'text-gray-700 hover:text-blue-700',
      countBg: 'bg-blue-100',
      countText: 'text-blue-800'
    },
    gray: {
      activeBg: 'bg-gradient-to-r from-gray-500 to-slate-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-gray-50',
      inactiveText: 'text-gray-700 hover:text-gray-700',
      countBg: 'bg-gray-100',
      countText: 'text-gray-800'
    }
  };
  const colorConfig = colors[color];
  return <button className={`flex items-center justify-between px-4 py-2 rounded-lg border transition-all ${active ? `${colorConfig.activeBg} border-transparent ${colorConfig.activeText} shadow-md` : `${colorConfig.inactiveBg} border-gray-300 ${colorConfig.inactiveText}`}`} onClick={onClick} data-id="element-6680">
      <span className="font-medium" data-id="element-6681">{label}</span>
      <span className={`ml-2 inline-flex items-center justify-center h-5 w-5 text-xs rounded-full ${active ? 'bg-white/20 text-white' : `${colorConfig.countBg} ${colorConfig.countText}`}`} data-id="element-6682">
        {count}
      </span>
    </button>;
}
// Helper component for sort options
function SortOption({
  label,
  active,
  onClick
}) {
  return <button className={`w-full text-left px-4 py-2 text-sm ${active ? 'bg-indigo-50 text-indigo-700 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} onClick={onClick} data-id="element-6683">
      <div className="flex items-center" data-id="element-6684">
        {active && <CheckIcon size={14} className="mr-2 text-indigo-600" data-id="element-6685" />}
        <span className={active ? 'ml-0' : 'ml-5'} data-id="element-6686">{label}</span>
      </div>
    </button>;
}
// Shopping cart icon component
function ShoppingCartIcon({
  size,
  className
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-6687">
      <circle cx="8" cy="21" r="1" data-id="element-6688" />
      <circle cx="19" cy="21" r="1" data-id="element-6689" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" data-id="element-6690" />
    </svg>;
}
// Machine Stock Card component
function MachineStockCard({
  machine
}) {
  const statusConfig = {
    Critical: {
      bg: 'bg-gradient-to-r from-red-50 to-rose-100',
      border: 'border-red-200',
      badge: 'bg-gradient-to-r from-red-500 to-rose-600 text-white',
      icon: <AlertCircleIcon size={16} className="mr-1 text-white" data-id="element-6691" />
    },
    Warning: {
      bg: 'bg-gradient-to-r from-amber-50 to-yellow-100',
      border: 'border-amber-200',
      badge: 'bg-gradient-to-r from-amber-500 to-yellow-600 text-white',
      icon: <AlertCircleIcon size={16} className="mr-1 text-white" data-id="element-6692" />
    },
    Good: {
      bg: 'bg-gradient-to-r from-blue-50 to-indigo-100',
      border: 'border-blue-200',
      badge: 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white',
      icon: <CheckCircleIcon size={16} className="mr-1 text-white" data-id="element-6693" />
    },
    Optimal: {
      bg: 'bg-gradient-to-r from-green-50 to-emerald-100',
      border: 'border-green-200',
      badge: 'bg-gradient-to-r from-green-500 to-emerald-600 text-white',
      icon: <CheckCircleIcon size={16} className="mr-1 text-white" data-id="element-6694" />
    }
  };
  const priorityConfig = {
    High: {
      bg: 'bg-red-100',
      text: 'text-red-800'
    },
    Medium: {
      bg: 'bg-amber-100',
      text: 'text-amber-800'
    },
    Low: {
      bg: 'bg-blue-100',
      text: 'text-blue-800'
    }
  };
  const trendConfig = {
    increasing: {
      icon: <TrendingUpIcon size={14} className="mr-1 text-green-600" data-id="element-6695" />,
      text: 'text-green-600'
    },
    decreasing: {
      icon: <TrendingDownIcon size={14} className="mr-1 text-red-600" data-id="element-6696" />,
      text: 'text-red-600'
    },
    stable: {
      icon: <ArrowRightIcon size={14} className="mr-1 text-blue-600" data-id="element-6697" />,
      text: 'text-blue-600'
    }
  };
  const config = statusConfig[machine.status];
  const priorityConf = priorityConfig[machine.priority];
  const trendConf = trendConfig[machine.trend];
  return <div className={`rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 ${config.bg} ${config.border}`} data-id="element-6698">
      <div className="p-5 relative" data-id="element-6699">
        <div className="flex justify-between items-start mb-3" data-id="element-6700">
          <div data-id="element-6701">
            <div className="flex items-center mb-1" data-id="element-6702">
              <span className={`px-2.5 py-1 rounded-full text-xs font-medium flex items-center ${config.badge}`} data-id="element-6703">
                {config.icon}
                {machine.status}
              </span>
              <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-medium ${priorityConf.bg} ${priorityConf.text}`} data-id="element-6704">
                {machine.priority} Priority
              </span>
            </div>
            <h3 className="font-bold text-xl text-gray-800" data-id="element-6705">{machine.name}</h3>
            <div className="flex items-center mt-1 text-gray-600 text-sm" data-id="element-6706">
              <TagIcon size={14} className="mr-1" data-id="element-6707" />
              {machine.type}
              <span className="mx-2" data-id="element-6708">•</span>
              <span className="text-xs bg-gray-100 px-2 py-0.5 rounded-full" data-id="element-6709">
                {machine.id}
              </span>
            </div>
          </div>
          <div className="bg-white/80 backdrop-blur-sm p-2 rounded-lg border border-gray-200 shadow-sm" data-id="element-6710">
            <div className="text-center" data-id="element-6711">
              <div className="text-xs text-gray-500" data-id="element-6712">Desired</div>
              <div className="text-lg font-bold text-indigo-700" data-id="element-6713">
                {machine.desiredStock}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 space-y-3" data-id="element-6714">
          {Object.entries(machine.stats).map(([key, value]) => {
          if (value === 0) return null;
          const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
          let color = 'green';
          if (key === 'lowStock') color = 'yellow';
          if (key === 'overStock') color = 'orange';
          if (key === 'orderRequired') color = 'red';
          return <StockProgressBar key={key} label={label} value={value} color={color} data-id="element-6715" />;
        })}
        </div>
        <div className="mt-5 grid grid-cols-2 gap-4 text-sm" data-id="element-6716">
          <div className="bg-white rounded-lg p-3 border border-gray-100 shadow-sm" data-id="element-6717">
            <div className="font-medium text-gray-700 mb-1" data-id="element-6718">At hand:</div>
            <div className="text-lg font-bold text-indigo-700" data-id="element-6719">
              {machine.atHand}
            </div>
          </div>
          <div className="bg-white rounded-lg p-3 border border-gray-100 shadow-sm" data-id="element-6720">
            <div className="font-medium text-gray-700 mb-1" data-id="element-6721">Incoming:</div>
            <div className="text-lg font-bold text-teal-600" data-id="element-6722">
              {machine.incoming}
            </div>
          </div>
        </div>
        <div className="mt-4 flex items-center justify-between" data-id="element-6723">
          <div className="text-sm flex items-center" data-id="element-6724">
            <CalendarIcon size={14} className="mr-1 text-gray-500" data-id="element-6725" />
            <span className="text-gray-600" data-id="element-6726">
              Updated: {machine.lastUpdated}
            </span>
          </div>
          <div className={`text-sm flex items-center ${trendConf.text}`} data-id="element-6727">
            {trendConf.icon}
            <span data-id="element-6728">Trend: {machine.trend}</span>
          </div>
        </div>
        <div className="mt-3 p-3 bg-white/60 backdrop-blur-sm rounded-lg border border-gray-200 text-sm text-gray-700" data-id="element-6729">
          <InfoIcon size={14} className="inline-block mr-1 text-indigo-600" data-id="element-6730" />
          {machine.forecast}
        </div>
      </div>
      <div className="border-t border-gray-200 p-2 flex justify-between bg-white/60 backdrop-blur-sm" data-id="element-6731">
        <button className="text-indigo-600 hover:text-indigo-800 font-medium flex items-center py-1.5 px-4 rounded-md hover:bg-white transition-colors" data-id="element-6732">
          <EyeIcon size={16} className="mr-2" data-id="element-6733" />
          View
        </button>
        <div className="flex" data-id="element-6734">
          <button className="text-gray-600 hover:text-gray-800 font-medium flex items-center py-1.5 px-4 rounded-md hover:bg-white transition-colors" data-id="element-6735">
            <EditIcon size={16} className="mr-2" data-id="element-6736" />
            Edit
          </button>
          <button className="text-gray-500 hover:text-gray-700 font-medium flex items-center py-1.5 px-3 rounded-md hover:bg-white transition-colors ml-1" data-id="element-6737">
            <SettingsIcon size={16} data-id="element-6738" />
          </button>
        </div>
      </div>
    </div>;
}